var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './DropdownList.module.scss';
import { v4 as uuid } from 'uuid';
import { ClickDetector } from '../ClickDetector/ClickDetector';
import { DropdownContainer } from '../DropdownContainer/DropdownContainer';
var DropdownList = function (_a) {
    var options = _a.options, selected = _a.selected, onSelect = _a.onSelect, className = _a.className, id = _a.id, dataId = _a.dataId, onClose = _a.onClose;
    var getOptionTestId = function (label) { return "".concat(label.replace(/ /g, '-').toLowerCase(), "-option"); };
    var renderOptions = useMemo(function () {
        if (!options.length)
            return _jsx("span", __assign({ className: styles.NoOptions }, { children: "No options" }));
        return (_jsx(_Fragment, { children: options.map(function (opt) {
                var _a;
                return (_jsx("li", __assign({ className: cx(styles.Option, (_a = {},
                        _a[styles.Active] = opt.value === (selected === null || selected === void 0 ? void 0 : selected.value),
                        _a[styles.Disabled] = opt.isDisabled,
                        _a)), onClick: function () { return onSelect(opt); }, "data-testid": getOptionTestId(opt.label) }, { children: opt.label }), uuid()));
            }) }));
    }, [options]);
    return (_jsx(ClickDetector, __assign({ onOutsideClick: onClose, dataId: 'detector' }, { children: _jsx(DropdownContainer, __assign({ className: className, id: id, dataId: dataId }, { children: _jsx("ul", __assign({ className: styles.Options }, { children: renderOptions })) })) })));
};
DropdownList.propTypes = {
    selected: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    }),
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
export { DropdownList };
//# sourceMappingURL=DropdownList.js.map